import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import '../../../assets/css/sliderprincipal.css';

const SliderPrincipalHome = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

const slides = [ 
  {
    bgImage: '/img/slides/waldir_pianos_slide1.webp',
    leftImage: '/img/slides/56_anos.webp',
    title: 'Desde 1968',
    description: 'Mais de 56 anos de tradição e paixão pelos pianos.'
  },
  {
    bgImage: '/img/slides/dani.jpg',
    leftImage: '/img/slides/56_anos.webp',
    title: 'Legado Familiar',
    description: 'Conhecimento passado de pai para filhos com dedicação.'
  },
  {
    bgImage: '/img/slides/waldir_pianos_slide3.webp',
    leftImage: '/img/slides/56_anos.webp',
    title: 'Obras de Arte',
    description: 'Reformas que aliam estética, música e excelência.'
  },
  {
    bgImage: '/img/slides/waldir_pianos_slide4.webp',
    leftImage: '/img/slides/56_anos.webp',
    title: 'Compre com garantia ',
    description: 'Pianos restaurados, descupinizados, revisados, regulados e afinados com garantia.'
  },
  {
    bgImage: '/img/slides/waldir_pianos_slide5.webp',
    leftImage: '/img/slides/56_anos.webp',
    title: 'Loja Própria ',
    description: 'Ampla variedade com as melhores marcas'
  }
];

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // AutoPlay
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 10000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  // Calcula a altura do slider baseado no aspect ratio da imagem
  const getSliderHeight = () => {
    if (windowSize.width < 768) {
      // Para mobile, usa 70% da largura da tela (ajuste conforme necessário)
      return `${windowSize.width * 0.7}px`;
    }
    return '80vh';
  };

  return (
    <div className='sliderprincipal' style={{ height: getSliderHeight() }}>
      <AnimatePresence mode='wait'>
        <div key={currentIndex} className="slide-background-wrapper">
          <motion.div
            className="slide-background"
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 5, scale: 1, transition: { duration: 6, ease: "linear" } }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
            style={{ 
              backgroundImage: `url(${slides[currentIndex].bgImage})`,
             
            }}
          />

          <div className="slide-content">
            {windowSize.width > 768 && (
              <motion.div 
                className="left-image-container"
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.5 }}
              >
                <img 
                  src={slides[currentIndex].leftImage} 
                  alt="Detalhe do piano" 
                  className="left-image"
                />
                <div className="vintage-overlay"></div>
              </motion.div>
            )}

            <motion.div
              className="text-content-slide"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.5 }}
            >
              <h2>{slides[currentIndex].title}</h2>
              <p>{slides[currentIndex].description}</p>
            </motion.div>
          </div>
        </div>
      </AnimatePresence>

      <button className="nav-button-slide prev" onClick={prevSlide}>
        <FiChevronLeft />
      </button>
      <button className="nav-button-slide next" onClick={nextSlide}>
        <FiChevronRight />
      </button>

      <div className="pagination">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`pagination-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default SliderPrincipalHome;